import { useQuery, useQueryClient } from "@tanstack/vue-query";
import { watch, Ref } from "vue";
import { FinOneModeloVehiculoAction } from "../../actions/modeloVehiculoActions";

export function useModeloVehiculoFindOne(id: Ref<string>) {
  const queryClient = useQueryClient();

  const query = useQuery({
    queryKey: ["ModeloVehiculoFindOne", id],
    queryFn: () => FinOneModeloVehiculoAction(id.value),
    enabled: () => !!id.value,
    staleTime: 60 * 1000, // 1 minuto
  });

  // Si cambia el ID, hacer prefetch
  watch(id, (newId) => {
    if (newId) {
      queryClient.prefetchQuery({
        queryKey: ["ModeloVehiculoFindOne", newId],
        queryFn: () => FinOneModeloVehiculoAction(newId),
      });
    }
  });

  return {
    ...query, // => { data, isPending, isError, error, refetch, ... }
  };
}
